import React, { FC } from 'react';
import { generatePath, useHistory } from 'react-router';
import { ROUTES } from '../../../constants/routes';
import { Cell, HeaderCell, Left, NoMatching, Row, RowsWrapper, Underlined, Wrapper } from './TableStyles';

type Props = {
    DocumentsRows: any[];
};
const DocumentsTable: FC<Props> = ({ DocumentsRows }) => {
  const history = useHistory();
  const onClick = row => {
    const path = generatePath(ROUTES.PERMIT, {
      projectId: row.projectId,
      permitId: row.permitId,
    });
    history.push(path);
  };

  return (
    <Wrapper>
      <Row>
        <HeaderCell>
          <Left>Project - Permit</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Permit Status</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Quantity</Left>
        </HeaderCell>
      </Row>
      <RowsWrapper>
        {DocumentsRows.length === 0 && <NoMatching>No matching records found</NoMatching>}
        {DocumentsRows.length > 0 &&
          DocumentsRows.map((document, index) => {
            return (
              <Row key={index}>
                <Cell>
                  <Left>
                    <Underlined onClick={e => onClick(document)}>{`${document.projectPermit}`}</Underlined>
                  </Left>
                </Cell>
                <Cell>
                  <Left>{document.permitStatus}</Left>
                </Cell>
                <Cell>
                  <Left>{document.quantity}</Left>
                </Cell>
              </Row>
            );
          })}
      </RowsWrapper>
    </Wrapper>
  );
};

export default DocumentsTable;
